import { create } from 'zustand';
import type { MenuItem } from '@/shell/Menus/types';

/** The popup that is currently up, and where its top-left corner belongs. */
export interface ContextMenuTarget {
  x: number;
  y: number;
  items: MenuItem[];
}

interface ContextMenuStore {
  open: ContextMenuTarget | null;
  show(x: number, y: number, items: MenuItem[]): void;
  hide(): void;
}

/**
 * The shell's one context menu.
 *
 * There is deliberately only ever a single popup: Windows never showed two at
 * once, and a store means the desktop, its icons, the taskbar and the task
 * buttons can all raise one without any of them owning the popup component.
 *
 * `show` always replaces — a right-click somewhere else while a menu is up
 * closes the old one on the way past (`DropdownMenu` dismisses itself on any
 * outside pointerdown) and then lands here with the new items.
 */
export const useContextMenuStore = create<ContextMenuStore>((set) => ({
  open: null,

  show: (x, y, items) => set({ open: { x, y, items } }),

  hide: () => set((s) => (s.open === null ? s : { open: null })),
}));
